import React, { useState, useEffect, forwardRef } from 'react';
import ReceiptLogo from 'Components/Logo/ReceiptLogo';
import { Grid } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableContainer from '@material-ui/core/TableContainer';
import ReactTable from 'Components/ReactTable/ReactTable';
import TableRow from '@material-ui/core/TableRow';
import NSDL_BANK_LOGO from 'Assets/Images/NSDL_BANK_LOGO.png';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Slide,
    Box
} from '@material-ui/core';
import { LOGO_URL, CLIENT_NAME } from 'Config';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { withStyles } from '@material-ui/core/styles';
import CommonPrint from 'Components/Print/CommonPrint';
import jsPDF from 'jspdf';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const StyledTableCell = withStyles((theme) => ({
    body: {
        fontSize: 16,
        fontWeight: 'bold'
    }
}))(TableCell);

export function AEPSPrintNew({
    isOpen,
    title,
    request,
    positiveButtonTitle,
    positiveButtonClick,
    negativeButtonTitle,
    negativeButtonClick
}) {
    const [open, setOpen] = useState(isOpen);
    const classes = commonStyle();

    const handleNegativeButtonClick = () => {
        setOpen(false);
        negativeButtonClick();
    };

    const handlePositiveA4ButtonClick = () => {
        let pageSize = 'A4';
        CommonPrint(pageSize);
        positiveButtonClick(request);
    };

    const handlePositiveA5ButtonClick = () => {
        let pageSize = 'A5';
        CommonPrint(pageSize);
        positiveButtonClick(request);
    };

    const handlePositiveDownlaodButtonClick = () => {
        const printElement = document.getElementById('DialogPrint');
        const originalHTML = printElement.innerHTML;
        // Replace currency symbols with ASCII equivalents temporarily
        const sanitizedHTML = originalHTML
            .replace(/₹/g, 'Rs.')
            .replace(/[^\x00-\x7F]/g, ''); // Remove all non-ASCII characters
        printElement.innerHTML = sanitizedHTML;
        // Rest of your PDF generation code...
        const doc = new jsPDF({
            orientation: 'portrait',
            unit: 'pt',
            format: 'a4',
            putOnlyUsedFonts: true,
            floatPrecision: 16
        });
        doc.html(printElement, {
            callback: function (doc) {
                // Restore original HTML
                printElement.innerHTML = originalHTML;
                // Add footer text
                doc.setTextColor(0, 0, 0);
                doc.setFontSize(10);
                doc.text(
                    'This is a system-generated receipt.',
                    40,
                    doc.internal.pageSize.height - 40
                );
                doc.save('AEPS_Receipt.pdf');
            },
            x: 10,
            y: 40,
            width: 500,
            windowWidth: 500,
            html2canvas: {
                scale: 0.8,
                useCORS: true,
                backgroundColor: '#FFFFFF',
                allowTaint: false,
                letterRendering: true
            }
        });
    };

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'success':
                return 'green';
            case 'failed':
            case 'failure':
            case 'refund':
                return 'red';
            case 'pending':
            case 'process':
                return 'orange';
            default:
                return 'orange';
        }
    };

    return (
        <Dialog
            classes={{ paperFullScreen: 'prePrint' }}
            open={open}
            onClose={() => {
                setOpen(false);
                negativeButtonClick(false);
            }}
            TransitionComponent={Transition}
        >
            <DialogTitle
                id="alert-dialog-title"
                className={classes.title}
                style={{
                    backgroundColor: getStatusColor(request.Status),
                    color: '#fff'
                }}
            >
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="DialogPrint">
                    <AEPSConfirmation request={request} />
                </DialogContentText>
            </DialogContent>
            <Box
                style={{
                    position: 'relative',
                    width: '100%',
                    zIndex: 0,
                    marginBottom: '16px',
                    padding: '10px',
                    backgroundColor: '#ccc',
                    color: '#000',
                    fontSize: '10px',
                    textAlign: 'center'
                }}
            >
                This is a system-generated receipt.
            </Box>
            <DialogActions displayPrint="none">
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                        <Button
                            onClick={handleNegativeButtonClick}
                            className={classes.CustomSecondaryButtonStylePopup}
                        >
                            {negativeButtonTitle
                                ? negativeButtonTitle
                                : 'Close'}
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                        <Button
                            onClick={handlePositiveDownlaodButtonClick}
                            className={classes.CustomPrimaryButtonStylePopup}
                        >
                            {positiveButtonTitle
                                ? positiveButtonTitle
                                : 'Download'}
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                        <Button
                            onClick={handlePositiveA4ButtonClick}
                            className={classes.CustomPrimaryButtonStylePopup}
                        >
                            {positiveButtonTitle
                                ? positiveButtonTitle
                                : 'A4 Print'}
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                        <Button
                            onClick={handlePositiveA5ButtonClick}
                            className={classes.CustomPrimaryButtonStylePopup}
                        >
                            {positiveButtonTitle
                                ? positiveButtonTitle
                                : 'A5 Print'}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}

const AEPSConfirmation = (request) => {
                                          useEffect(() => {
                                              fetchCName();
                                              fetchLogoURL();
                                          }, []);

                                          const [
                                              logoURL,
                                              setLogoURL
                                          ] = useState('');

                                          async function fetchLogoURL() {
                                              setLogoURL(await LOGO_URL());
                                          }

                                          const [cName, setCName] = useState(
                                              ''
                                          );

                                          async function fetchCName() {
                                              setCName(await CLIENT_NAME());
                                          }

                                          const NsdlBankLogo = () => {
                                              return (
                                                  <img
                                                      src={NSDL_BANK_LOGO}
                                                      width={200}
                                                      alt="LOGO"
                                                      style={{
                                                          display: 'block',
                                                          visibility: 'visible',
                                                          opacity: 1
                                                      }}
                                                  />
                                              );
                                          };

                                          const ReceiptLogo = () => {
                                              return (
                                                  <img
                                                      src={logoURL}
                                                      width={100}
                                                      alt="NLOGO"
                                                      style={{
                                                          display: 'block',
                                                          visibility: 'visible',
                                                          opacity: 1
                                                      }}
                                                  />
                                              );
                                          };

                                          const parseMiniStatements = (
                                              statements
                                          ) => {
                                              return statements;
                                          };
                                          const parseReportMiniStatements = (
                                              statements
                                          ) => {
                                              if (!statements) return [];

                                              if (Array.isArray(statements))
                                                  return statements;

                                              if (
                                                  typeof statements === 'string'
                                              ) {
                                                  return statements
                                                      .split('",')
                                                      .map((item) =>
                                                          item
                                                              .trim()
                                                              .replace(
                                                                  /^"\*{0,2}/,
                                                                  ''
                                                              )
                                                              .replace(/"/g, '')
                                                      )
                                                      .filter(
                                                          (item) =>
                                                              item.trim() !== ''
                                                      );
                                              }
                                              return [];
                                          };
                                          let data = request.request;
                                          let AvailableBalance =
                                              data.AccBalance;
                                          // let rawTransactions = data.ministatements;
                                          // let transactions;
                                          // if (rawTransactions != null) {
                                          //     transactions = parseMiniStatements(rawTransactions);
                                          // }

                                          let rawMiniTransactions =
                                              data.ReportMiniStatement;
                                          let reportMiniStatement = parseReportMiniStatements(
                                              rawMiniTransactions
                                          );

                                          const transactionDetails = [
                                              {
                                                  label: 'Date & Time',
                                                  value: data.DOC ?? 'NA'
                                              },
                                              {
                                                  label: 'Agent Name',
                                                  value: data.FirmName
                                              },
                                              {
                                                  label: 'Product Name',
                                                  value:
                                                      data.ServiceName ?? 'NA'
                                              },
                                              {
                                                  label: 'Service Name',
                                                  value:
                                                      data.ProductName ?? 'NA'
                                              },

                                              ...(data.AEPSResponseJSON
                                                  ? [
                                                        {
                                                            label:
                                                                'Available Balance (₹)',
                                                            value:
                                                                data.AEPSResponseJSON
                                                        }
                                                    ]
                                                  : []),
                                              ...(data.ProductName?.toLowerCase() !==
                                                  'mini statement' &&
                                              data.ProductName?.toLowerCase() !==
                                                  'balance enquiry'
                                                  ? [
                                                        {
                                                            label: 'Amount (₹)',
                                                            value: data.Amount
                                                        }
                                                    ]
                                                  : []),
                                              {
                                                  label: 'Transaction ID',
                                                  value:
                                                      data.TransactionID ?? '0'
                                              },
                                              {
                                                  label: 'RRN',
                                                  value: data.ReferenceNo
                                              },
                                              {
                                                  label:
                                                      'Customer Mobile Number',
                                                  value: data.MobileNumber
                                              },
                                              {
                                                  label:
                                                      'Customer Aadhaar Number',
                                                  value: data.ConsumerNumber
                                              },
                                              {
                                                  label: 'Bank Name',
                                                  value: data.BankName
                                              },

                                              ...(AvailableBalance?.toString().trim()
                                                  ? [
                                                        {
                                                            label:
                                                                'Available Balance (₹)',
                                                            value: AvailableBalance
                                                        }
                                                    ]
                                                  : []),
                                              ...(data.Status?.toLowerCase() ===
                                                  'failure' ||
                                              data.Status?.toLowerCase() ===
                                                  'failed'
                                                  ? [
                                                        {
                                                            label: 'Message',
                                                            value:
                                                                data.Description
                                                        }
                                                    ]
                                                  : [])
                                          ];

                                          const isBlank = (param) => {
                                              if (param === undefined)
                                                  return true;
                                              if (param === null) return true;
                                              if (param === '0') return true;
                                              if (param === '') return true;
                                              return false;
                                          };

                                          const getStatusColor = (status) => {
                                              switch (status?.toLowerCase()) {
                                                  case 'success':
                                                      return 'green';
                                                  case 'failed':
                                                  case 'failure':
                                                      return 'red';
                                                  case 'pending':
                                                  case 'process':
                                                      return 'orange';
                                                  default:
                                                      return 'orange';
                                              }
                                          };

                                          return (
                                              <Grid item xs={12}>
                                                  <Grid item xs={12}>
                                                      <Box
                                                          style={{
                                                              border:
                                                                  '2px solid #000',
                                                              padding: '5px',
                                                              marginTop: '5px',
                                                              marginLeft: '5px',
                                                              backgroundColor:
                                                                  '#fff',
                                                              width: '450px',
                                                              height: 'auto',
                                                              position:
                                                                  'relative',
                                                              paddingTop:
                                                                  '15px',
                                                              fontFamily:
                                                                  'Arial Unicode MS, Noto Sans Devanagari, Arial, sans-serif'
                                                          }}
                                                      >
                                                          <Grid
                                                              style={{
                                                                  display:
                                                                      'flex',
                                                                  justifyContent:
                                                                      'space-between',
                                                                  flex: 'auto',
                                                                  alignItems:
                                                                      'center',
                                                                  marginBottom:
                                                                      '10px'
                                                              }}
                                                          >
                                                              <NsdlBankLogo />
                                                              <ReceiptLogo />
                                                          </Grid>
                                                          <TableContainer>
                                                              <h4
                                                                  style={{
                                                                      textAlign:
                                                                          'center',
                                                                      padding:
                                                                          '10px 0',
                                                                      paddingTop:
                                                                          '40px',
                                                                      color:
                                                                          '#000',
                                                                      fontFamily:
                                                                          'Arial Unicode MS, Noto Sans Devanagari, Arial, sans-serif'
                                                                  }}
                                                              >
                                                                  Transaction
                                                                  Details
                                                              </h4>

                                                              <TableContainer>
                                                                  <Table>
                                                                      <TableBody>
                                                                          <TableRow>
                                                                              <StyledTableCell
                                                                                  style={{
                                                                                      padding:
                                                                                          '8px 0 8px 15px',
                                                                                      fontFamily:
                                                                                          'Arial Unicode MS, Noto Sans Devanagari, Arial, sans-serif'
                                                                                  }}
                                                                              >
                                                                                  Transaction
                                                                                  Status
                                                                              </StyledTableCell>
                                                                              <StyledTableCell
                                                                                  style={{
                                                                                      padding:
                                                                                          '8px 0 8px 15px',
                                                                                      fontFamily:
                                                                                          'Arial Unicode MS, Noto Sans Devanagari, Arial, sans-serif'
                                                                                  }}
                                                                              >
                                                                                  <span
                                                                                      style={{
                                                                                          fontSize:
                                                                                              '14px',
                                                                                          color: getStatusColor(
                                                                                              data.Status
                                                                                          ),
                                                                                          fontWeight:
                                                                                              'normal',
                                                                                          marginLeft:
                                                                                              '8px',
                                                                                          paddingLeft:
                                                                                              '25px',
                                                                                          fontFamily:
                                                                                              'Arial Unicode MS, Noto Sans Devanagari, Arial, sans-serif'
                                                                                      }}
                                                                                  >
                                                                                      <b>
                                                                                          {data.Status ??
                                                                                              'NA'}
                                                                                      </b>
                                                                                  </span>
                                                                              </StyledTableCell>
                                                                          </TableRow>
                                                                          {transactionDetails.map(
                                                                              (
                                                                                  detail,
                                                                                  index
                                                                              ) => (
                                                                                  <TableRow
                                                                                      key={
                                                                                          index
                                                                                      }
                                                                                  >
                                                                                      <StyledTableCell
                                                                                          style={{
                                                                                              padding:
                                                                                                  '8px 0 8px 15px',
                                                                                              fontFamily:
                                                                                                  'Arial Unicode MS, Noto Sans Devanagari, Arial, sans-serif'
                                                                                          }}
                                                                                      >
                                                                                          <span className="currency-symbol">
                                                                                              {
                                                                                                  detail.label
                                                                                              }
                                                                                          </span>
                                                                                      </StyledTableCell>
                                                                                      <StyledTableCell
                                                                                          style={{
                                                                                              padding:
                                                                                                  '8px 0 8px 25px',
                                                                                              fontFamily:
                                                                                                  'Arial Unicode MS, Noto Sans Devanagari, Arial, sans-serif'
                                                                                          }}
                                                                                      >
                                                                                          <span
                                                                                              style={{
                                                                                                  fontSize:
                                                                                                      '14px',
                                                                                                  color:
                                                                                                      '#000',
                                                                                                  fontWeight:
                                                                                                      'normal',
                                                                                                  fontFamily:
                                                                                                      'Arial Unicode MS, Noto Sans Devanagari, Arial, sans-serif'
                                                                                              }}
                                                                                              className="currency-symbol"
                                                                                          >
                                                                                              {
                                                                                                  detail.value
                                                                                              }
                                                                                          </span>
                                                                                      </StyledTableCell>
                                                                                  </TableRow>
                                                                              )
                                                                          )}
                                                                      </TableBody>
                                                                  </Table>
                                                                  {/* {transactions && transactions.length > 0 && (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        width: '100%'
                                    }}
                                >
                                    <Table size="small">
                                        <TableBody>
                                            {transactions.map((line, index) => (
                                                <TableRow key={index}>
                                                    <StyledTableCell
                                                        colSpan={4}
                                                        style={{
                                                            textAlign: 'center',
                                                            fontFamily:
                                                                'Arial Unicode MS, Noto Sans Devanagari, Arial, sans-serif'
                                                        }}
                                                    >
                                                        {line}
                                                    </StyledTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </div>
                            )} */}
                                                                  {reportMiniStatement?.length >
                                                                      0 && (
                                                                      <div
                                                                          style={{
                                                                              marginTop:
                                                                                  '20px'
                                                                          }}
                                                                      >
                                                                          <h4
                                                                              style={{
                                                                                  textAlign:
                                                                                      'center',
                                                                                  padding:
                                                                                      '10px 0',
                                                                                  color:
                                                                                      '#000',
                                                                                  fontFamily:
                                                                                      'Arial Unicode MS, Noto Sans Devanagari, Arial, sans-serif'
                                                                              }}
                                                                          >
                                                                              Mini
                                                                              Statement
                                                                          </h4>
                                                                          <div
                                                                              style={{
                                                                                  display:
                                                                                      'flex',
                                                                                  justifyContent:
                                                                                      'center',
                                                                                  width:
                                                                                      '100%'
                                                                              }}
                                                                          >
                                                                              <Table size="small">
                                                                                  <TableBody>
                                                                                      {reportMiniStatement.map(
                                                                                          (
                                                                                              line,
                                                                                              index
                                                                                          ) => (
                                                                                              <TableRow
                                                                                                  key={
                                                                                                      index
                                                                                                  }
                                                                                              >
                                                                                                  <StyledTableCell
                                                                                                      colSpan={
                                                                                                          4
                                                                                                      }
                                                                                                      style={{
                                                                                                          textAlign:
                                                                                                              'left',
                                                                                                          fontFamily:
                                                                                                              'Arial Unicode MS, Noto Sans Devanagari, Arial, sans-serif',
                                                                                                          whiteSpace:
                                                                                                              'pre-line',
                                                                                                          padding:
                                                                                                              '8px 16px'
                                                                                                      }}
                                                                                                  >
                                                                                                      {
                                                                                                          line
                                                                                                      }
                                                                                                  </StyledTableCell>
                                                                                              </TableRow>
                                                                                          )
                                                                                      )}
                                                                                  </TableBody>
                                                                              </Table>
                                                                          </div>
                                                                      </div>
                                                                  )}
                                                              </TableContainer>
                                                          </TableContainer>
                                                      </Box>
                                                  </Grid>
                                              </Grid>
                                          );
                                      };
